import type { Platform } from '../../../context/env-context';
import { getSrc } from '../../utils';
import bigcommerce from './bigcommerce.png';
import custom from './custom.png';
import magento from './magento.png';
import shopify from './shopify.png';
import wix from './wix.png';
import woocommerce from './woocommerce.png';

const LOGOS: Record<Platform, string> = {
  shopify: getSrc(shopify),
  shopify_plus: getSrc(shopify),
  bigcommerce: getSrc(bigcommerce),
  wix: getSrc(wix),
  woocommerce: getSrc(woocommerce),
  magento: getSrc(magento),
  custom: getSrc(custom),
};

export function getPlatformLogo(platform: Platform): string {
  return LOGOS[platform];
}
